// Re:Focus — Network Helpers
// Centralized fetch error handling for fire-and-forget API calls

/**
 * Fire-and-forget fetch that logs failures and shows offline banner on network errors.
 * Use for non-critical background API calls (delegate enqueue, flag dismiss, etc.)
 * where the primary data is already saved locally.
 */
export function backgroundFetch(url, options = {}) {
  return fetch(url, options).catch((err) => {
    console.warn('[Re:Focus] Background request failed:', url, err.message || err);
    const banner = document.getElementById('offline-banner');
    if (banner) banner.classList.remove('hidden');
  });
}
